// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1osq{width:100%}\n._1e0c11p5{display:grid}\n._1p57pxbi{row-gap:var(--ds-space-200,1pc)}\n._p12ffkat{max-width:386px}", ""]);
// Exports
module.exports = exports;
